export default __webpack_public_path__ + "static/media/no_item.f3c24303.svg";